import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {UserInterface} from "../models/user-interface";
import {Employee} from "../models/employee";
import {Office} from "../models/office";
import {Site} from "../models/site";
import {FormGroup} from "@angular/forms";
import {Certificato} from "../models/certificati-interface";
import {ListaServizi, Servizio} from "../models/servizio";
import {Appuntamento, AppuntamentoPage} from "../models/appuntamento";
import {OrariLavorativi} from 'app/models/orari-lavorativi';
import {TributoMessage} from "../models/tributo";
import {PagamentoMessage} from "../models/pagamento";
import {Documento} from "../models/payment-notices-response";

@Injectable({providedIn: 'root'})
export class MessageService {
  user: UserInterface[] = [];
  employee: Employee[] = [];
  service: Servizio [] = [];
  listService!: ListaServizi;
  office: Office[] = [];
  sede: Site[] = []
  certificato!: Certificato;
  appuntamento: Appuntamento[] = [];
  singleAppuntamento!: AppuntamentoPage;
  orariLavorativi!: OrariLavorativi;
  form!: FormGroup;
  tributo!: TributoMessage;
  pagamento!: PagamentoMessage;
  pagamentoTributo!: Documento;

  private user_interface = new BehaviorSubject<UserInterface[]>(this.user);
  private employee_interface = new BehaviorSubject<Employee[]>(this.employee);
  private service_interface = new BehaviorSubject<Servizio[]>(this.service);
  private office_interface = new BehaviorSubject<Office[]>(this.office);
  private site_interface = new BehaviorSubject<Site[]>(this.sede);
  private formGroup = new BehaviorSubject<FormGroup>(this.form);
  private certificato_interface = new BehaviorSubject<Certificato>(this.certificato);
  private appuntamento_interface = new BehaviorSubject<Appuntamento[]>(this.appuntamento);
  private single_appuntamento_interface = new BehaviorSubject<AppuntamentoPage>(this.singleAppuntamento);
  private orariLavorativi_interface = new BehaviorSubject<OrariLavorativi>(this.orariLavorativi);
  private listaService_interface = new BehaviorSubject<ListaServizi>(this.listService);
  private tributo_interface = new BehaviorSubject<TributoMessage>(this.tributo);
  private pagamento_interface = new BehaviorSubject<PagamentoMessage>(this.pagamento);
  private attivita_subject = new Subject<string>();
  private pagamento_subject = new BehaviorSubject(this.pagamentoTributo);

  userMessage = this.user_interface.asObservable();
  employeeMessage = this.employee_interface.asObservable();
  officeMessage = this.office_interface.asObservable();
  siteMessage = this.site_interface.asObservable();
  formMessage = this.formGroup;
  certificatoMessage = this.certificato_interface.asObservable();
  serviceMessage = this.service_interface.asObservable();
  orariMessage = this.orariLavorativi_interface.asObservable();
  appointmentMessage = this.appuntamento_interface.asObservable();
  listaServiceMessage = this.listaService_interface.asObservable();
  singleAppointmentMessage = this.single_appuntamento_interface.asObservable();
  tributoMessage = this.tributo_interface.asObservable();
  pagamentoMessage = this.pagamento_interface.asObservable();
  attivita = this.attivita_subject.asObservable();
  pagamentoTributoMessage = this.pagamento_subject.asObservable();

  sendUserInterface(message: UserInterface[]): void {
    this.user_interface.next(message);
  }

  sendEmployeeInterface(message: Employee[]): void {
    this.employee_interface.next(message);
  }

  sendServiceInterface(message: Servizio[]): void {
    this.service_interface.next(message);
  }

  sendOfficeInterface(message: Office[]): void {
    this.office_interface.next(message);
  }

  sendSiteInterface(message: Site[]): void {
    this.site_interface.next(message);
  }

  sendForm(message: FormGroup): void {
    this.formGroup.next(message);
  }

  sendCertificato(message: Certificato): void {
    this.certificato_interface.next(message);
  }

  sendSingleAppointmentInterface(message: AppuntamentoPage): void {
    this.single_appuntamento_interface.next(message)
  }

  sendAppointmentInterface(message: Appuntamento[]): void {
    this.appuntamento_interface.next(message)
  }

  sendOrariLavorativi(message: OrariLavorativi): void {
    this.orariLavorativi_interface.next(message)
  }

  sendListaService(message: ListaServizi): void {
    this.listaService_interface.next(message);
  }

  sendTributo(message: TributoMessage): void {
    this.tributo_interface.next(message);
  }

  sendPagamento(message: PagamentoMessage): void{
    this.pagamento_interface.next(message);
  }

  sendPagamentoTributo(message: Documento): void{
    this.pagamento_subject.next(message);
  }

  sendAttivita(): void {
    this.attivita_subject.next("Attività");
  }

}
